import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
const Photo = x => x;
const newtypePhoto_ = {Coercible0: () => {}};
const eqPhoto = {eq: x => y => x === y};
const genericPhoto = {to: x => x, from: x => x};
const showPhoto = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showStringImpl(v)]})({reflectSymbol: () => "Photo"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodePhoto = {unsafeDecode: x => Unscramble.decodeString(x)};
const encodePhoto = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPhoto)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Photo"})({
    encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
  }))
};
const decodePhoto = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPhoto)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "Photo"})({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {Photo, decodePhoto, encodePhoto, eqPhoto, genericPhoto, newtypePhoto_, showPhoto, unscrambleDecodePhoto};
